import { plainToClass } from 'class-transformer';
import {
  API_CLIENT_REMINDER_CREATE,
  API_CLIENT_REMINDER_DELETE,
  API_CLIENT_REMINDER_FIND_ALL,
  API_CLIENT_REMINDER_FIND_ONE,
  API_CLIENT_REMINDER_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { ClientReminderDto } from '../dto';
import { FindAllResponse } from '../types';

export class ClientReminderApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<ClientReminderDto>> {
    return this.httpClient
      .get(API_CLIENT_REMINDER_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(ClientReminderDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<ClientReminderDto> {
    return this.httpClient
      .get(API_CLIENT_REMINDER_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(ClientReminderDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<ClientReminderDto> {
    return this.httpClient
      .post(API_CLIENT_REMINDER_CREATE, data)
      .then(({ data }) => {
        return plainToClass(ClientReminderDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<ClientReminderDto> {
    return this.httpClient
      .put(API_CLIENT_REMINDER_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(ClientReminderDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_CLIENT_REMINDER_DELETE, {
      pathParams: { uuid }
    });
  }
}
